import {ReviewSummary} from 'notebook/reviews/ReviewConstants';

export enum ConfigSavingState {
  NOT_EDITING = 'NOT_EDITING',
  EDITING = 'EDITING',
  SAVING = 'SAVING',
}

export enum ReviewCriterionStatus {
  UNREVIEWED = 'UNREVIEWED',
  PASSED = 'PASSED',
  FAILED = 'FAILED',
}
export const REVIEW_CRITERION_STATUS = ReviewCriterionStatus;

/**
 * @deprecated Use ReviewConstants.ReviewSummary directly
 */
export type Review = ReviewSummary;

export interface ReviewCriterion {
  id?: string | null;
  text: string;
  status: ReviewCriterionStatus;
}

export interface SavedReviewCriterion extends ReviewCriterion {
  id: string;
}

export interface ReviewCriteriaGroup {
  id?: string | null;
  name: string;
  reviewCriteria: Array<ReviewCriterion>;
}

export interface SavedReviewCriteriaGroup {
  id: string;
  name: string;
  reviewCriteria: Array<SavedReviewCriterion>;
}
